import React from 'react';

import ReactModal from 'react-modal';
import { Icon } from 'src/common/components/Icon';
import { OrbitIcons } from 'src/common/constants.';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  isDeleting?: boolean;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isDeleting = false,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal modal-sm"
      overlayClassName="overlay"
      appElement={document.querySelector('#root') as HTMLElement}
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full">
            <Icon name={OrbitIcons.AlertCircle} size={24} className="text-red-600" />
          </div>
          <h2 className="text-lg font-bold text-black-1.0">{title}</h2>
        </div>

        <p className="text-sm text-gray-2.0">{message}</p>

        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} disabled={isDeleting} className="btn btn-ghost">
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="btn hover:bg-red-700 disabled:opacity-50 text-white bg-red-600"
          >
            {isDeleting ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </ReactModal>
  );
};
